export const singleIntoArray = (arr, obj) => {
  const existing = arr.find((item) => item.id === obj.id);
  const newObj = existing ? { ...existing, ...obj } : obj;
  return [...arr.filter((item) => item.id !== obj.id), newObj];
};

export default {
  singleIntoArray,
};
